import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dd3c52e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "print" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","margin-top":"24px","margin-bottom":"15px"} }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block","width":"62px"} }, "打印机", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10px","margin-left":"20px","color":"red"} }, "温馨提示：下载打印控件时请检查打印控件与操作系统版本（32位/64位）是否一致；执行标签打印时请选择标签打印机打印与正确的纸张大小打印", -1))
const _hoisted_6 = { class: "search-condition" }
const _hoisted_7 = { class: "top-condition" }
const _hoisted_8 = { class: "search" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "69码", -1))
const _hoisted_10 = { class: "search-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "货号", -1))
const _hoisted_12 = { class: "search-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "陈列区域", -1))
const _hoisted_14 = { class: "search-btns" }
const _hoisted_15 = { class: "tables" }
const _hoisted_16 = { class: "bottom-condition" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "扫码打印", -1))
const _hoisted_18 = { class: "printbtn" }
const _hoisted_19 = { class: "printbtn" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "打印列表", -1))

import { OioButton, OioInput, OioSelect } from '@kunlun/vue-ui-antd';
import { ref, reactive, onMounted, watch } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'ScanPrint',
  props: {
    onEnterSearch: null,
    dataSourceList: null,
    dataSourceWait: null,
    isShowPrintBtn: { type: Boolean },
    searchByParms: null,
    onSelectChange: null,
    selectedRowKeys: null,
    onPrintf: null,
    searchParams: null,
    resetParams: null,
    printerOptions: null,
    printerChange: null,
    backAndSaveIds: null,
    viewName: null
  },
  setup(__props: any) {

const props = __props as {
  onEnterSearch: () => void;
  dataSourceList: any[];
  dataSourceWait: any[];
  isShowPrintBtn: boolean;
  searchByParms: any;
  onSelectChange: (selectedRowKeys: string[], selectedRows: any[]) => void;
  selectedRowKeys: string[];
  onPrintf: () => void;
  searchParams: {
    barCode: string;
    itemNumber: string;
    area: string;
    printerValue: string;
    printerTemp: string;
  };
  resetParams: () => void;
  printerOptions: any[];
  printerChange: (value: string) => void;
  backAndSaveIds: () => void;
  viewName: string;
}



const printerName = ref('');
const printerValue = ref('ITEM');
const printerTemp = ref('NEW_HTML');
const printerValueOption = ref([{ value: 'ITEM', label: '按货号' }, { value: 'SKU', label: '按商品' }]);
const printTempOptions = ref([{ value: 'NEW_HTML', label: '新品会模版' }, { value: 'ITEM_HTML', label: '门店模版' }, { value: 'NO_PRICE_HTML', label: '无价格模版' }]);
const columns = reactive<any[]>([
  {
    title: '展会编码',
    dataIndex: 'exhibitionCode',
    align: 'center',
    resizable: true,
    width: 130,
  },
  {
    title: '展会名称',
    dataIndex: 'exhibitionName',
    resizable: true,
    align: 'center',
    width: 150,
  },
  {
    title: '品牌',
    dataIndex: 'brandName',
    resizable: true,
    align: 'center',
    width: 100,
  },
  {
    title: '商品名称',
    dataIndex: 'itemName',
    resizable: true,
    align: 'center',
    width: 280,
  },
  {
    title: '商品编码',
    dataIndex: 'itemCode',
    resizable: true,
    align: 'center',
    width: 200,
  },
  {
    title: '货号',
    dataIndex: 'itemNumber',
    resizable: true,
    align: 'center',
    width: 100,
  },
  {
    title: '69码',
    dataIndex: 'barCode',
    resizable: true,
    align: 'center',
    width: 180,
  },
  {
    title: '销售单价',
    dataIndex: 'itemSalesUnitPrice',
    resizable: true,
    align: 'center',
    width: 150,
  },
  {
    title: '陈列区域',
    dataIndex: 'displayArea',
    resizable: true,
    align: 'center',
    width: 120,
  },
  {
    title: '备注',
    dataIndex: 'remark',
    resizable: true,
    align: 'center',
    width: 120,
  },
]);

onMounted(() => {
  console.log(props.searchParams);
  props.searchParams.area = '';
  if (props.searchParams.printerTemp) {
    printerTemp.value = props.searchParams.printerTemp;
  }
  props.searchParams.printerValue = 'ITEM';
});

watch(
    () => props.printerOptions,
    (val) => {
      printerName.value = sessionStorage.getItem('printName') || val[0]?.value || '';
    }
);

watch(
    () => props.viewName,
    (val) => {
      if (val && val !== '得力-订货会扫码打印_DETAIL_0000000000011504') {
        columns[7].title = '打印价格';
      }
    },
    {
      immediate: true,
    }
);

const handleResizeColumn = (w: number, col: any) => {
  col.width = w;
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(OioSelect), {
          value: printerName.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((printerName).value = $event)),
          options: __props.printerOptions,
          placeholder: "请选择打印机",
          style: {"width":"229px"},
          onChange: __props.printerChange
        }, null, 8, ["value", "options", "onChange"])
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_unref(OioInput), {
            value: __props.searchParams.barCode,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((__props.searchParams.barCode) = $event)),
            placeholder: "扫码枪输入",
            onPressEnter: __props.onEnterSearch,
            style: {"width":"229px"}
          }, null, 8, ["value", "onPressEnter"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_unref(OioInput), {
            value: __props.searchParams.itemNumber,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((__props.searchParams.itemNumber) = $event)),
            placeholder: "请输入货号",
            style: {"width":"229px"}
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_unref(OioInput), {
            value: __props.searchParams.area,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((__props.searchParams.area) = $event)),
            placeholder: "请输入陈列区域",
            style: {"width":"229px"}
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: __props.onEnterSearch,
            style: {"margin-right":"20px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("搜索")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_unref(OioButton), { onClick: __props.resetParams }, {
            default: _withCtx(() => [
              _createTextVNode("重置")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_a_select, {
            class: "oio-select",
            "dropdown-class-name": "oio-select-dropdown login-oio-select-dropdown",
            value: __props.searchParams.printerValue,
            "show-search": "",
            style: {"width":"180px"},
            onChange: _cache[4] || (_cache[4] = (value) => __props.searchParams.printerValue = value)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printerValueOption.value, (country, index) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  title: country.label,
                  value: country.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(country.label), 1)
                  ]),
                  _: 2
                }, 1032, ["title", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_a_select, {
            class: "oio-select",
            "dropdown-class-name": "oio-select-dropdown login-oio-select-dropdown",
            value: __props.searchParams.printerTemp,
            "show-search": "",
            style: {"width":"180px"},
            onChange: _cache[5] || (_cache[5] = (value) => __props.searchParams.printerTemp = value)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printTempOptions.value, (country, index) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  title: country.label,
                  value: country.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(country.label), 1)
                  ]),
                  _: 2
                }, 1032, ["title", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(OioButton), {
            class: "printbtn ant-btn-primary",
            onClick: __props.onPrintf
          }, {
            default: _withCtx(() => [
              _createTextVNode("打印")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_a_table, {
        dataSource: __props.dataSourceList,
        "row-selection": {
          selectedRowKeys: __props.selectedRowKeys,
          onChange: __props.onSelectChange
        },
        columns: columns,
        onResizeColumn: handleResizeColumn,
        sticky: "",
        locale: { emptyText: '暂无数据' },
        rowKey: (record) => record.id,
        align: "center",
        scroll: { y: 272, x: true },
        class: "printTable",
        pagination: false,
        rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
        bordered: ""
      }, null, 8, ["dataSource", "row-selection", "columns", "rowKey", "rowClassName"]),
      _hoisted_20,
      _createVNode(_component_a_table, {
        dataSource: __props.dataSourceWait,
        columns: columns,
        pagination: { pageSize: 10 },
        align: "center",
        onResizeColumn: handleResizeColumn,
        sticky: "",
        locale: { emptyText: '暂无数据' },
        scroll: { x: true, y: true },
        rowKey: (record) => record.id,
        class: "waitTable",
        rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
        bordered: ""
      }, null, 8, ["dataSource", "columns", "rowKey", "rowClassName"])
    ])
  ]))
}
}

})